// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb004cfd","453":"c1b05076","732":"498f0e5a","977":"7729cd47"}[chunkId] + ".chunk.js";
};